// Utilidades para el sistema de formularios

// Generar ID único
export const generateId = () => {
  return Math.random().toString(36).substr(2, 9);
};

// Crear componente base
export const createBaseComponent = (type, x = 0, y = 0) => {
  return {
    id: generateId(),
    type,
    x,
    y,
    width: 200,
    height: 40,
    locked: false,
  };
};

// Validar formulario
export const validateForm = (components) => {
  const errors = [];

  components.forEach((component, index) => {
    if (component.required) {
      if (component.type === "input" || component.type === "textArea") {
        if (!component.value || component.value.trim() === "") {
          errors.push({
            componentId: component.id,
            message: `El campo "${component.label}" es requerido`,
          });
        }
      } else if (component.type === "select") {
        if (!component.selectedOption) {
          errors.push({
            componentId: component.id,
            message: `Debe seleccionar una opción en "${component.label}"`,
          });
        }
      } else if (component.type === "radiobutton") {
        if (!component.selectedOption) {
          errors.push({
            componentId: component.id,
            message: `Debe seleccionar una opción en "${component.label}"`,
          });
        }
      } else if (component.type === "checklist") {
        if (!component.selectedOptions || component.selectedOptions.length === 0) {
          errors.push({
            componentId: component.id,
            message: `Debe seleccionar al menos una opción en "${component.label}"`,
          });
        }
      }
    }
  });

  return errors;
};

// Obtener datos del formulario
export const getFormData = (components) => {
  const formData = {};

  components.forEach((component) => {
    if (component.type === "input" || component.type === "textArea") {
      formData[component.id] = component.value || "";
    } else if (component.type === "select") {
      formData[component.id] = component.selectedOption || "";
    } else if (component.type === "radiobutton") {
      formData[component.id] = component.selectedOption || "";
    } else if (component.type === "checklist") {
      formData[component.id] = component.selectedOptions || [];
    }
  });

  return formData;
};

// Exportar formulario como JSON
export const exportFormAsJSON = (formName, components) => {
  const formData = {
    name: formName,
    components: components,
    createdAt: new Date().toISOString(),
    version: "1.0",
  };

  return JSON.stringify(formData, null, 2);
};

// Importar formulario desde JSON
export const importFormFromJSON = (jsonString) => {
  try {
    const formData = JSON.parse(jsonString);
    return {
      name: formData.name || "Formulario importado",
      components: formData.components || [],
    };
  } catch (error) {
    console.error("Error al importar formulario:", error);
    return null;
  }
};

// Ordenar componentes por posición Y
export const sortComponentsByPosition = (components) => {
  return [...components].sort((a, b) => a.y - b.y);
};

// Duplicar componente
export const duplicateComponent = (component) => {
  return {
    ...component,
    id: generateId(),
    x: component.x + 20,
    y: component.y + 20,
  };
};

// Verificar si un componente está en el área visible
export const isComponentInViewport = (component, viewport) => {
  return (
    component.x < viewport.width &&
    component.x + component.width > 0 &&
    component.y < viewport.height &&
    component.y + component.height > 0
  );
};

// Calcular el tamaño mínimo del canvas basado en los componentes
export const calculateCanvasSize = (components) => {
  if (components.length === 0) {
    return { width: 800, height: 600 };
  }

  const maxX = Math.max(...components.map((c) => c.x + c.width));
  const maxY = Math.max(...components.map((c) => c.y + c.height));

  return {
    width: Math.max(800, maxX + 100),
    height: Math.max(600, maxY + 100),
  };
};
